export default __webpack_public_path__ + "static/media/calender_background.52f04512.png";